import { mapActions, mapGetters, mapMutations } from "vuex";
import moment from "moment";

function getRangeDate(start, end) {
    if (!start || !end) return "";
    const startDate = moment(start);
    const endDate = moment(end);
    const duration = moment.duration(startDate.diff(endDate));
    return duration.asSeconds();
}

export default {
    name: "home-work-header",
    props: ["hasTimer"],
    data() {
        return {
            countdownTime: "00 : 00",
            time: "",
            errorClass: false,
        };
    },
    watch: {
        currentTest: {
            deep: true,
            handler() {
                this.resetTime();
                this.setDate();
            },
        },
        header: {
            deep: true,
            handler() {
                this.resetTime();
                this.setDate();
            },
        },
    },
    computed: {
        ...mapGetters({
            header: "coursesHomeWork/header",
            serverTime: "setting/serverTime",
            currentTest: "coursesHomeWork/currentTest",
            currentItem: "coursesHomeWork/currentItem",
        }),

        hasPractic() {
            return this.currentItem.type === "text";
        },

        route() {
            return this.$route.name.includes("home-work")
                ? {
                      name: "courses-dashboard",
                      params: { item: this.$route.params.item },
                  }
                : { name: "tests" };
        },

        calculationTimeModule() {
            if (!this.currentTest) return "00 : 00";
            if (!this.currentTest.currentQuestion.data.hasOwnProperty("responseTime"))
                return "00 : 00";

            const duration = this.currentTest.currentQuestion.data.responseTime;
            const minutes = Math.floor(duration / 60);
            const seconds = duration % 60;

            return `${minutes > 9 ? minutes : "0" + minutes} : ${
                seconds > 9 ? seconds : "0" + seconds
            }`;
        },
        startedQuestionDate() {
            if (!this.currentTest) return "";
            return this.currentTest.currentUserQuestion.data.hasOwnProperty("startedAt")
                ? this.currentTest.currentUserQuestion.data.startedAt
                : this.currentTest.startedAt;
        },
        endedQuestionDate() {
            if (!this.currentTest) return "";
            return moment(this.startedQuestionDate)
                .add(this.currentTest.responseTime, "seconds")
                .format("YYYY-MM-DD HH:mm:ss");
        },
    },

    mounted() {
        this.setDate();
    },
    methods: {
        ...mapActions({
            fetchServerTime: "setting/GET_SERVER_TIME",
        }),
        ...mapMutations({
            changeHeader: "coursesHomeWork/CHANGE_HEADER",
            changeShowPopup: "tests/CHANGE_POPUP_CANCEL_TEST",

            changeHeaderHomeWork: "coursesHomeWork/CHANGE_HEADER",
            changeHeaderTest: "tests/CHANGE_HEADER",
        }),
        setDate() {
            this.fetchServerTime().then(() => {
                clearInterval(this.time);
                this.errorClass = false;
                const progressTimeQuestion = getRangeDate(
                    this.serverTime,
                    this.startedQuestionDate
                );
                this.timer(progressTimeQuestion);
            });
        },
        resetTime() {
            this.countdownTime = "00 : 00";
            clearInterval(this.time);
            this.errorClass = false;
        },
        closeTest() {
            console.log("this.hasPractic", this.hasPractic);
            if (this.hasPractic) {
                this.navigateTo();
                return;
            }

            if (this.$route.path.includes("/questions")) {
                this.changeShowPopup(true);
            } else {
                try {
                    this.$router.push(this.header.parentRoute);
                } catch (e) {
                    console.log(e);
                }
                this.changeHeader({
                    show: false,
                    parentRoute: "",
                });
                clearInterval(this.time);
            }
        },
        /**
         *
         * @param duration
         */
        timer(duration = 0) {
            if (!duration) return;
            let time = duration;
            this.time = setInterval(() => {
                time++;
                if (this.currentTest.currentQuestion.data.responseTime < time) {
                    this.errorClass = true;
                    const currentTime = this.currentTest.currentQuestion.data
                        .responseTime;
                    const minutes = Math.floor(currentTime / 60);
                    const seconds = currentTime % 60;
                    this.countdownTime = `${minutes > 9 ? minutes : "0" + minutes} : ${
                        seconds > 9 ? seconds : "0" + seconds
                    }`;
                } else {
                    const minutes = Math.floor(time / 60);
                    const seconds = time % 60;
                    this.countdownTime = `${minutes > 9 ? minutes : "0" + minutes} : ${
                        seconds > 9 ? seconds : "0" + seconds
                    }`;
                }
            }, 1000);
        },

        navigateTo() {
            try {
                this.changeShowPopup(false);
                this.changeHeaderTest({ show: false, parentRoute: "" });
                this.changeHeaderHomeWork({ show: false, parentRoute: "" });
                this.$router.push(this.route);
            } catch (e) {
                console.log(e);
            }
        },
    },
    destroyed() {
        clearInterval(this.time);
        this.changeHeader({
            show: false,
        });
    },
};
